import { render, staticRenderFns } from "./editScoreScaleDeveloped.vue?vue&type=template&id=dddfa660&scoped=true"
import script from "./editScoreScaleDeveloped.vue?vue&type=script&lang=js"
export * from "./editScoreScaleDeveloped.vue?vue&type=script&lang=js"
import style0 from "./editScoreScaleDeveloped.vue?vue&type=style&index=0&id=dddfa660&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dddfa660",
  null
  
)

export default component.exports